import { DatePipe } from '@angular/common';
import { Component, inject, OnDestroy } from '@angular/core';
import { TableRowDirective } from '@core/primevue/directives/table-row.directive';
import dayjs from 'dayjs';
import { Button } from 'primeng/button';
import { ProgressBarModule } from 'primeng/progressbar';
import { TableModule } from 'primeng/table';
import { BatchService } from '../batch.service';
import { BatchJobStatus } from './batch-job-status.model';

@Component({
  selector: 'app-batch-job-status',
  imports: [
    DatePipe,
    TableRowDirective,
    TableModule,
    ProgressBarModule,
    Button,
  ],
  templateUrl: './batch-job-status.component.html',
  styleUrl: './batch-job-status.component.css',
})
export class BatchJobStatusComponent implements OnDestroy {
  batchService = inject(BatchService);
  statusData = this.batchService.batchJobStatusDatasource.data;

  timer = setInterval(() => this.batchService.refreshData(), 15000);

  ngOnDestroy(): void {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  beregnetSlutTid(estimeretRestTid?: number) {
    return dayjs()
      .add(estimeretRestTid || 0, 'second')
      .toDate();
  }

  onClickAfbryd(batchJobStatus: BatchJobStatus) {
    this.batchService.afbrydJob(batchJobStatus.batchJob);
  }
}
